import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import { RellenoMaterialComponent } from '../relleno-material/relleno-material.component';
import { GalleryItem, ImageItem } from 'ng-gallery';

@Component({
  selector: 'app-relleno-scan-material',
  templateUrl: './relleno-scan-material.component.html',
  styleUrls: ['./relleno-scan-material.component.scss']
})
export class RellenoScanMaterialComponent {

  image: any;
  lineas: { line: number, estaciones: number, alertas: number, color: string, colorBorde: string }[] = [];
  lineasFiltradas: { line: number, estaciones: number, alertas: number, color: string, colorBorde: string }[] = [];

  lineaSeleccionadaId: number = 1;
  estacionSeleccionada: string = '';
  sku: string = '';
  nombre_mat: string = '';

  datosLineas: { nombre: string, line: number, color: string, colorBorde: string, cantidad: number, cantidad_total: number }[] = [];
  estacionesFiltradas: { nombre: string, line: number, color: string, colorBorde: string, cantidad: number, cantidad_total: number }[] = [];

  lineas_unicas = [];
  campaignSelected: any;
  estacionesIds: string[] = [];
  id_mat_camp: number = 0;
  items: GalleryItem[] = [];

  zoom = 1;
  maxZoom = 3;
  minZoom = 1;
  showModal = false;
  posX = 0;
  posY = 0;

  isDragging = false;
  startX = 0;
  startY = 0;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private matDialog: MatDialog,
  ) { }

  ngOnInit(): void {

    this.sku = this.data.scan;
    this.nombre_mat = this.data.materialEncontrado[0].nombre_mat;
    this.lineas = this.data.lineas;
    this.image = this.data.materialEncontrado[0].img;
    this.datosLineas = this.data.datosLineas;

    const lineasIds = this.data.materialEncontrado.map((m: any) => m.line);
    this.estacionesIds = this.data.materialEncontrado.map((m: any) => m.estacion);

    this.lineasFiltradas = this.lineas.filter((item: any) => lineasIds.includes(item.line));
    this.lineaSeleccionadaId = this.lineasFiltradas[0].line;
    //this.seleccionarLinea(this.lineaSeleccionadaId);
    this.campaignSelected = this.data.campaign;
    this.id_mat_camp = this.data.materialEncontrado[0].id_mat_camp;

    if (this.image) {
      this.items = [
        new ImageItem({ src: this.image, thumb: this.image })
      ];
    }

    this.estacionesFiltradas = this.datosLineas.filter((item: any) => (this.estacionesIds.includes(item.nombre)));

    this.estacionesFiltradas.map((item:any) => {
      const res = this.data.materialEncontrado.find((obj:any) => obj.estacion == item.nombre);
      if(res){
        item.cantidad = res.cantidad;
        item.cantidad_total = res.cantidad_total;
      }
    })

  }

  seleccionarLinea(line: number) {
    this.estacionSeleccionada = '';
    this.lineaSeleccionadaId = line;
    this.estacionesFiltradas = this.datosLineas.filter((item: any) => (item.line == line && this.estacionesIds.includes(item.nombre)));

    this.estacionesFiltradas.map((item:any) => {
      const res = this.data.materialEncontrado.find((obj:any) => obj.estacion == item.nombre);
      if(res){
        item.cantidad = res.cantidad ?? 0;
        item.cantidad_total = res.cantidad_total;
      }
    })
  
  }

  seleccionarEstacion(estacion: any) {

    const search_mat = this.data.materialEncontrado.find((obj: any) => obj.estacion == estacion.nombre);

    if (search_mat.cantidad == 0) {
      search_mat.color = '#FED3C8';
      search_mat.color2 = '#FDA994';
    }
    else if (search_mat.cantidad < search_mat.limite_minimo) {
      search_mat.color = '#FEE9B8';
      search_mat.color2 = '#FED67C';
    }
    else {
      search_mat.color = '#C9EECC';
      search_mat.color2 = '#75D17A';
    }

    this.openRellenoMaterial(search_mat, search_mat.tipo)

  }

  openRellenoMaterial(row: any, tipo: string) {

    let camp = this.campaignSelected;

    this.matDialog.open(RellenoMaterialComponent, {
      panelClass: ['dialogs-md'],
      data: {
        ...row,
        tipo,
        camp
      }
    }).afterClosed().subscribe(
      resp => {
        if (resp?.reload) {
          /* this.getLineasEstaciones(this.campaignSelected);
          this.seleccionarLinea(this.lineaSeleccionadaId); */
        }
      }
    );

  }

  zoomIn() {
    if (this.zoom < this.maxZoom) {
      this.zoom += 0.2;
    }
  }
  zoomOut() {
    if (this.zoom > this.minZoom) {
      this.zoom -= 0.2;
    }
  }
  open() {
    this.showModal = true;
  }
  close() {
    this.showModal = false;
  }

  get transform() {
    return `translate(${this.posX}px, ${this.posY}px) scale(${this.zoom})`;
  }

  startDrag(event: MouseEvent) {
    if (this.zoom <= 1) return;

    this.isDragging = true;
    this.startX = event.clientX - this.posX;
    this.startY = event.clientY - this.posY;
  }

  onDrag(event: MouseEvent) {
    if (!this.isDragging) return;

    this.posX = event.clientX - this.startX;
    this.posY = event.clientY - this.startY;
  }

  endDrag() {
    this.isDragging = false;
  }

  resetPosition() {
    this.posX = 0;
    this.posY = 0;
  }

}
